import { render, staticRenderFns } from "./previousStock.vue?vue&type=template&id=16b5c3b0&"
import script from "./previousStock.vue?vue&type=script&lang=js&"
export * from "./previousStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports